const setEndOfContenteditable = (el) => {
  const sel = window.getSelection();
  sel.selectAllChildren(el);
  sel.collapseToEnd();
};

export { setEndOfContenteditable }